export const getShortAddressStr = (address = "") => {
  address = typeof address === "string" ? address : "";

  return address === "" ? "" : address.slice(0, 5) + "..." + address.slice(-5);
};
